module.exports = __webpack_public_path__ + "static/media/cloud-showers-heavy.4680fc56.svg";